define(
    'NMSDesignSystem.ProductionCompatibility.Shopping',
    [
        'Profile.Model',
        'Configuration',
        'ItemSegmentation.Utils',
        'underscore'
    ],
    function NMSDesignSystemProductionCompatibilityShopping(
        ProfileModel,
        Configuration,
        ItemSegmentationUtils,
        _
    ) {
        'use strict';

        ProfileModel = ProfileModel.ProfileModel || ProfileModel;
        Configuration = Configuration.Configuration || Configuration;

        function preserveProductionItemSegmentation() {
            var profile = ProfileModel.getInstance();
            var customerCategory = profile.get('isLoggedIn') === 'T'
                ? _.findWhere(profile.get('customfields'), {name: 'custentity6'})
                : null;
            var categoryFilter = customerCategory &&
                ItemSegmentationUtils.getCustomerCategoryFacetFilter(customerCategory.value);
            var originalAddToSearchOptions = ItemSegmentationUtils.addToSearchAPIMasterOptions;

            function preservePcvFlag(options) {
                if (categoryFilter && categoryFilter.urlComponent) {
                    _.each(options, function addPcvFlag(option) {
                        option.use_pcv = 'F';
                    });
                }
                return options;
            }

            preservePcvFlag(Configuration.searchApiMasterOptions);
            if (!ItemSegmentationUtils.nmsProductionPcvPreserved) {
                ItemSegmentationUtils.addToSearchAPIMasterOptions = function addProductionSearchOptions(options) {
                    return preservePcvFlag(originalAddToSearchOptions.apply(this, arguments));
                };
                ItemSegmentationUtils.nmsProductionPcvPreserved = true;
            }
        }

        return {
            mountToApp: function mountToApp() {
                preserveProductionItemSegmentation();
            }
        };
    }
);
